import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDropdownModule, NgbNavModule, NgbTooltipModule, NgbPaginationModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { EntityTreeComponent } from './entity-tree/entity-tree.component';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { MbscModule } from '@mobiscroll/angular';
import { EntityMgmtComponent } from './entity-mgmt/entity-mgmt.component';
import { EntityEditComponent } from './entity-edit/entity-edit.component';
import { EntityMoveComponent } from './entity-move/entity-move.component';
import { ViewEntityAssignmentComponent } from './view-entity-assignment/view-entity-assignment.component';
import { LocationPropertiesComponent } from './location-properties/location-properties.component';
import { EntityImportComponent } from './entity-import/entity-import.component';

@NgModule({
  declarations: [
    EntityTreeComponent,
    EntityMgmtComponent,
    EntityEditComponent,
    EntityMoveComponent,
    ViewEntityAssignmentComponent,
    LocationPropertiesComponent,
    EntityImportComponent
  ],
  imports: [
    CommonModule,
    NgbNavModule,
    NgbDropdownModule,
    NgbPaginationModule,
    NgbTooltipModule,
    NgbTypeaheadModule,
    FormsModule,
    CoreModule,
    MalihuScrollbarModule,
    MbscModule
  ]
})
export class EntitiesModule { }
